import React from 'react';
import InputConsumer from '../InputConsumer';
import { classes } from './Group.st.css';

const Group = ({ children }: { children?: React.ReactNode }) => (
  <InputConsumer consumerCompName={Group.displayName}>
    {() => <div className={classes.root}>{children}</div>}
  </InputConsumer>
);

Group.displayName = 'Input.Group';
export default Group;
